import { JUMP_START, START, TIRE_CHANGE, TOW } from "../../../app-consts/appConstants";

export const isRescueEligibleForPepCoupon = (serviceType: string) => {
  return serviceType === TOW || serviceType === JUMP_START || serviceType === START || serviceType === TIRE_CHANGE;
};
